import { Component, ElementRef, ViewChild } from "@angular/core";
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { GuiderService } from './guider.service';

@Component({
  selector: 'guider',
  templateUrl: './guider.component.html',
  styleUrls: ['./guider.component.scss']
})
export class GuiderComponent {
  @ViewChild('confirmModalContent') confirmModalContentRef: ElementRef;

  constructor( private readonly modalService: NgbModal,
               private readonly guiderService:GuiderService) { }

  openGuideModal() {
    const modalRef = this.modalService.open(this.confirmModalContentRef,{ size: 'sm', centered: true });
    modalRef.result.then(
      (res) => {
        if (res === 'Cancel click') {
          return;
        } else {
          this.guiderService.startGuidedTour();
        }
      }
    );
  }
}
